/** How many sidebar rows stay visible before „Mehr anzeigen“. */
export const INTRANET_SIDEBAR_PREVIEW = 6;

/** Collapses a list to `limit` until expanded. Search callers should skip this and show every hit. */
export function previewItems<T>(
  items: readonly T[],
  expanded: boolean,
  limit = INTRANET_SIDEBAR_PREVIEW,
): { items: readonly T[]; collapsed: boolean; canCollapse: boolean } {
  const overflow = items.length > limit;
  const collapsed = overflow && !expanded;
  return {
    items: collapsed ? items.slice(0, limit) : items,
    collapsed,
    canCollapse: overflow && expanded,
  };
}
